import { MapPin } from "lucide-react";
import { Badge } from "@/components/ui/badge";

interface LocationsListProps {
  locations: string[];
}

export const LocationsList = ({ locations }: LocationsListProps) => {
  if (!locations || locations.length === 0) {
    return null;
  }

  return (
    <div className="p-4 border rounded-lg">
      <h4 className="font-medium flex items-center gap-2 mb-3">
        <MapPin className="h-4 w-4 text-blue-500" />
        Supported Locations ({locations.length})
      </h4>
      
      <div className="flex flex-wrap gap-2">
        {locations.map((location, index) => (
          <Badge 
            key={index} 
            variant="outline" 
            className="bg-blue-50 text-blue-700 hover:bg-blue-100 border-blue-200"
          >
            {location}
          </Badge>
        ))}
      </div>
    </div>
  );
};
